// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import __setDefaultSdkOptions from "../sdk-helpers/__setDefaultSdkOptions";

import createAvatarSet from "./avatar/postAvatarSet";
import createBlockAdd from "./block/postBlockAdd";
import createBlockList from "./block/postBlockList";
import createBlockRemove from "./block/postBlockRemove";
import createFanFollowAccept from "./fanFollow/postFanFollowAccept";
import createFanFollowCancel from "./fanFollow/postFanFollowCancel";
import createFanFollowFollowersList from "./fanFollow/postFanFollowFollowersList";
import createFanFollowFollowingList from "./fanFollow/postFanFollowFollowingList";
import createFanFollowReject from "./fanFollow/postFanFollowReject";
import createFanFollowRemoveFollower from "./fanFollow/postFanFollowRemoveFollower";
import createFanFollowRequest from "./fanFollow/postFanFollowRequest";
import createFanFollowRequestCount from "./fanFollow/postFanFollowRequestCount";
import createFanFollowRequestsList from "./fanFollow/postFanFollowRequestsList";
import createFollowsSet from "./follows/postFollowsSet";
import createProfileGet from "./profile/postProfileGet";
import createProfileGetForAccount from "./profile/postProfileGetForAccount";
import createProfileSearchByUsername from "./profile/postProfileSearchByUsername";
import createProfileUpdate from "./profile/postProfileUpdate";
import createTeamFollowAdd from "./teamFollow/postTeamFollowAdd";
import createTeamFollowRemove from "./teamFollow/postTeamFollowRemove";
import createUsernameCheck from "./username/postUsernameCheck";
import createUsernameClaim from "./username/postUsernameClaim";

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

// Every method is built from RESOLVED options, never the raw argument.
// `sdk()` with no arguments has to work. That is the shape every generated
// hook uses through useCallSdk(), and passing the raw `undefined` through
// gave those methods no apiHost and no "/v1/<zone>" prefix, so they POSTed to
// a bare relative "/resource/action".
export default function sdk(options?: SdkOptions) {
  const resolvedOptions = __setDefaultSdkOptions(options);
  return {
    postAvatarSet: createAvatarSet(resolvedOptions),
    postBlockAdd: createBlockAdd(resolvedOptions),
    postBlockList: createBlockList(resolvedOptions),
    postBlockRemove: createBlockRemove(resolvedOptions),
    postFanFollowAccept: createFanFollowAccept(resolvedOptions),
    postFanFollowCancel: createFanFollowCancel(resolvedOptions),
    postFanFollowFollowersList: createFanFollowFollowersList(resolvedOptions),
    postFanFollowFollowingList: createFanFollowFollowingList(resolvedOptions),
    postFanFollowReject: createFanFollowReject(resolvedOptions),
    postFanFollowRemoveFollower: createFanFollowRemoveFollower(resolvedOptions),
    postFanFollowRequest: createFanFollowRequest(resolvedOptions),
    postFanFollowRequestCount: createFanFollowRequestCount(resolvedOptions),
    postFanFollowRequestsList: createFanFollowRequestsList(resolvedOptions),
    postFollowsSet: createFollowsSet(resolvedOptions),
    postProfileGet: createProfileGet(resolvedOptions),
    postProfileGetForAccount: createProfileGetForAccount(resolvedOptions),
    postProfileSearchByUsername: createProfileSearchByUsername(resolvedOptions),
    postProfileUpdate: createProfileUpdate(resolvedOptions),
    postTeamFollowAdd: createTeamFollowAdd(resolvedOptions),
    postTeamFollowRemove: createTeamFollowRemove(resolvedOptions),
    postUsernameCheck: createUsernameCheck(resolvedOptions),
    postUsernameClaim: createUsernameClaim(resolvedOptions),
  };
}
